module.exports = __webpack_public_path__ + "static/media/complex-garden1.55bd27a3.jpg";